import { Icon, IconButton } from '@kontentino/ui';
import React, { useCallback, useEffect } from 'react';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import DomUtils from 'app/utils/dom';
import { usePostCommunicationContext } from '../PostCommunicationProvider';
import { queryKey } from 'constants/queryKey';
import { queryClient } from 'api/client';
import useBoolean from 'utils/hooks/useBoolean';
import clsx from 'clsx';
const SCROLL_THRESHOLD = -200;

const GoToNewestCommentButton = () => {
  const [isVisible, setIsVisible] = useBoolean(false);
  const [isLoading, setIsLoading] = useBoolean(false);
  const { commentsListRef } = usePostCommunicationContext();

  const scrollToBottom = () => {
    DomUtils.scrollToBottom(commentsListRef.current, {
      delay: 100,
    });
  };

  const goToNewestComment = async () => {
    setIsLoading.on();
    await queryClient.refetchQueries(queryKey.postCommentsThread());
    setIsLoading.off();
    scrollToBottom();
  };

  const handleScroll = useCallback((event: Event) => {
    const target = event.target as HTMLElement;
    // We are scrolling up so scroll distance is negative number
    target.scrollTop < SCROLL_THRESHOLD
      ? setIsVisible.on()
      : setIsVisible.off();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const element = commentsListRef.current;
    if (!element) return;
    element?.addEventListener('scroll', handleScroll);

    return () => {
      element?.removeEventListener('scroll', handleScroll);
    };
  }, [commentsListRef, handleScroll]);

  return (
    <IconButton
      isLoading={isLoading}
      className={clsx(
        'tw-h-8 tw-w-8 tw-rounded-full tw-border tw-border-grayscale-20 tw-bg-white',
        {
          'tw-flex': isVisible,
          'tw-hidden': !isVisible,
        },
      )}
      variant="plain"
      icon={<Icon icon={faChevronDown} />}
      onClick={goToNewestComment}
    />
  );
};

export default GoToNewestCommentButton;
